import React from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"

import {UserForm} from "~/components/"

const NewUserView = ({user, match}) => {
  const tenant = match.params.tenant || localStorage.subdomain
  const isInOwnTenant = tenant === localStorage.subdomain

  const afterFormLink = isInOwnTenant ? "/users" : "/tenants/" + tenant

  return (
    <UserForm id={match.params.user_id} tenant={tenant} then={afterFormLink} />
  )
}

NewUserView.propTypes = {
  user: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  return {user}
}

export default connect(mapStateToProps)(NewUserView)



// WEBPACK FOOTER //
// ./src/views/NewUserView.js